import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import {
    statusLabel,
    statusBadge,
    statusIcon,
    currencyLabel,
    saleNumber,
    wakilCode,
} from "./orderStatus";

const formatDate = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "—";
    return date.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
};

class ScroollTableOrders extends React.Component {
    // Which row the list has already scrolled to. The mark on the last opened
    // order (OR_activeId) survives the trip to its invoice, but the table body
    // is its own scroll container and remounts at the top — so without this the
    // row comes back marked yet off-screen.
    scrolledTo = null;

    // Stable identity: React then calls it only when the marked row mounts or
    // unmounts, not on every re-render.
    markActiveRow = (node) => {
        if (!node) return;
        const id = node.dataset.orderId;
        if (this.scrolledTo === id) return;
        this.scrolledTo = id;

        const wrap = node.closest(".rs-table-wrap");
        if (!wrap) return;
        const wrapBox = wrap.getBoundingClientRect();
        const rowBox = node.getBoundingClientRect();
        // Already fully in view — the usual case when the row was just clicked.
        // Centering it there would yank the list out from under the click.
        if (rowBox.top >= wrapBox.top && rowBox.bottom <= wrapBox.bottom) return;
        // Scroll the wrapper only (not scrollIntoView, which would drag the
        // whole page along with it).
        wrap.scrollTop +=
            rowBox.top - wrapBox.top - (wrap.clientHeight - rowBox.height) / 2;
    };

    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const { OR_data, OR_OpenModal, OR_activeId } = value;

                    return (
                        <div className="rs-card">
                            <div className="rs-table-wrap">
                                <table className="rs-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "120px" }}>ژمارە</th>
                                            <th className="is-center" style={{ width: "130px" }}>
                                                ژمارەی وەسڵ
                                            </th>
                                            <th>کڕیار</th>
                                            <th className="is-center" style={{ width: "160px" }}>
                                                کۆدی کڕیار
                                            </th>
                                            <th style={{ width: "160px" }}>شار</th>
                                            <th className="is-center" style={{ width: "90px" }}>
                                                کاڵا
                                            </th>
                                            <th style={{ width: "170px" }}>کۆی گشتی</th>
                                            <th className="is-center" style={{ width: "140px" }}>
                                                دۆخ
                                            </th>
                                            <th style={{ width: "150px" }}>بەروار</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {OR_data.map((order, i) => {
                                            const customer = order.customer || {};
                                            const itemCount = Array.isArray(order.items)
                                                ? order.items.length
                                                : 0;
                                            // Set once the order is accepted and its Sale
                                            // invoice exists.
                                            const waslNo = saleNumber(order.saleRef);
                                            // Same story: who the wasl is billed to. No code
                                            // on an invoiced order means it was sold direct,
                                            // not that the customer is unknown — so that
                                            // reads as a label, and only an order still
                                            // waiting for its invoice shows a dash.
                                            const code = wakilCode(order);
                                            const isActive =
                                                !!OR_activeId &&
                                                String(order._id) === OR_activeId;
                                            return (
                                                <tr
                                                    key={order._id || i}
                                                    data-order-id={order._id}
                                                    ref={isActive ? this.markActiveRow : null}
                                                    className={`rs-clickable${
                                                        isActive ? " rs-row--active" : ""
                                                    }`}
                                                    onClick={() => OR_OpenModal(order._id)}
                                                >
                                                    <td>
                                                        <span className="rs-code rs-strong rs-num">
                                                            #{order.orderNumber}
                                                        </span>
                                                    </td>
                                                    <td className="is-center">
                                                        {order.saleRef ? (
                                                            <span className="rs-badge rs-badge--green">
                                                                <i className="fas fa-file-invoice"></i>
                                                                <span className="rs-num">
                                                                    {waslNo !== null ? `#${waslNo}` : "هەیە"}
                                                                </span>
                                                            </span>
                                                        ) : (
                                                            <span className="rs-dim">—</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <span className="rs-strong">
                                                            {customer.name || "—"}
                                                        </span>
                                                        <span className="rs-sub rs-num">
                                                            {customer.phone || "—"}
                                                        </span>
                                                    </td>
                                                    <td className="is-center">
                                                        {code ? (
                                                            <span className="btn btn-sm btn-success text-white rs-num">
                                                                {code}
                                                            </span>
                                                        ) : order.saleRef ? (
                                                            <span className="btn btn-sm btn-danger text-white">
                                                                فرۆشتنی راستەخۆ
                                                            </span>
                                                        ) : (
                                                            <span className="rs-dim">—</span>
                                                        )}
                                                    </td>
                                                    <td>{customer.city || customer.address || "—"}</td>
                                                    <td className="is-center rs-num">{itemCount}</td>
                                                    <td className="rs-money">
                                                        <span className="rs-num">
                                                            <NumberFormat
                                                                value={order.total}
                                                                displayType="text"
                                                                thousandSeparator={true}
                                                            />
                                                        </span>{" "}
                                                        {currencyLabel(order.currency)}
                                                    </td>
                                                    <td className="is-center">
                                                        <span className={`rs-badge ${statusBadge(order.status)}`}>
                                                            <i className={`fas ${statusIcon(order.status)}`}></i>
                                                            {statusLabel(order.status)}
                                                        </span>
                                                    </td>
                                                    <td className="rs-num">{formatDate(order.createdAt)}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {OR_data.length === 0 && (
                                <div className="rs-empty">
                                    <i className="fas fa-inbox"></i>
                                    <p>هیچ داواکارییەک نەدۆزرایەوە</p>
                                </div>
                            )}
                        </div>
                    );
                }}
            </ProductConsumer>
        );
    }
}

export default ScroollTableOrders;
